import script from "./ChartCentreLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartCentreLoading.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__